export default {
      id: "common__dry_trailer-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__dry_trailer",
      toString: function () {
        return this.url;
      }
    }